var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFocussed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 30,
    fill: "#F9F7FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4158_34301)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36 39.33C36 39.6892 35.6391 39.985 35.191 39.985L24.8131 40C24.3672 40 24 39.7093 24 39.3484V38.67C24 38.3108 24.3589 38.015 24.809 38.015L35.1869 38C35.6328 38 36 38.2907 36 38.6516V39.33Z",
    fill: "#1E1E1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 30.0011C50 41.0513 41.0492 50.0022 29.9989 50.0022C18.9487 50.0022 10 41.0492 10 30.0011C10 18.953 18.9508 10 30.0011 10C41.0513 10 50.0022 18.9508 50.0022 30.0011M48.0914 29.9837C48.0914 20.0092 39.9995 11.9173 30.0249 11.9173C20.0504 11.9173 11.9585 20.0092 11.9585 29.9837C11.9585 39.9583 20.0504 48.0502 30.0249 48.0502C39.9995 48.0502 48.0914 39.9583 48.0914 29.9837Z",
    fill: "#1E1E1D"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 26,
    r: 5.1,
    stroke: "#1E1E1D",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37,
    cy: 26,
    r: 5.1,
    stroke: "#1E1E1D",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 25.5C28.6667 24.5 30.4 23.1 32 25.5",
    stroke: "black",
    strokeWidth: 1.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4158_34301"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFocussed);
export default __webpack_public_path__ + "static/media/focussed.0e4685e419eb876b446218f00f6669fa.svg";
export { ForwardRef as ReactComponent };